/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxChars: NonNullable<unknown>, maxLines: NonNullable<unknown> }} Error_Nav_Text_Content_ExceedsInputs */

const en_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Text content exceeds maximums (Max Chars: ${i?.maxChars}, Max Lines: ${i?.maxLines}).`)
};

const fr_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le contenu depasse les maximums (Max caracteres : ${i?.maxChars}, Max lignes : ${i?.maxLines}).`)
};

const de_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Textinhalt überschreitet die Maximalwerte (Maximale Zeichenanzahl: ${i?.maxChars}, Maximale Zeilenanzahl: ${i?.maxLines}).`)
};

const it_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il contenuto del testo supera i limiti massimi (numero massimo di caratteri: ${i?.maxChars}, numero massimo di righe: ${i?.maxLines}).`)
};

const ru_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Содержимое текста превышает максимально допустимые значения (Максимальное количество символов: ${i?.maxChars}, Максимальное количество строк: ${i?.maxLines}).`)
};

const es_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El contenido del texto excede los máximos (Máximo de caracteres: ${i?.maxChars}, Máximo de líneas: ${i?.maxLines}).`)
};

const zh_cn2_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文本内容超过最大值（最大字符数：${i?.maxChars}，最大行数：${i?.maxLines}）。`)
};

const ja_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`テキストの内容が最大値を超えています (最大文字数: ${i?.maxChars}、最大行数: ${i?.maxLines})。`)
};

const hi_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पाठ सामग्री अधिकतम सीमा से अधिक है (अधिकतम अक्षर: ${i?.maxChars}, अधिकतम पंक्तियाँ: ${i?.maxLines})।`)
};

const pt_pt2_error_nav_text_content_exceeds = /** @type {(inputs: Error_Nav_Text_Content_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O conteúdo do texto excede os limites máximos (Máx. de caracteres: ${i?.maxChars}, Máx. de linhas: ${i?.maxLines}).`)
};

/**
* | output |
* | --- |
* | "Text content exceeds maximums (Max Chars: {maxChars}, Max Lines: {maxLines})." |
*
* @param {Error_Nav_Text_Content_ExceedsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_text_content_exceeds = /** @type {((inputs: Error_Nav_Text_Content_ExceedsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Text_Content_ExceedsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_text_content_exceeds(inputs)
	if (locale === "de") return de_error_nav_text_content_exceeds(inputs)
	if (locale === "it") return it_error_nav_text_content_exceeds(inputs)
	if (locale === "ru") return ru_error_nav_text_content_exceeds(inputs)
	if (locale === "es") return es_error_nav_text_content_exceeds(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_text_content_exceeds(inputs)
	if (locale === "ja") return ja_error_nav_text_content_exceeds(inputs)
	if (locale === "hi") return hi_error_nav_text_content_exceeds(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_text_content_exceeds(inputs)
	return en_error_nav_text_content_exceeds(inputs)
});